<template>
  <b-modal size="xl" scrollable content-class="openProject" v-model="isShow">
    <template #modal-title>
      {{ $t('Open Project') }}
    </template>
    <b-container fluid>
      <b-tabs content-class="mt-3" v-model="tabIndex" v-show="!isShowProject">
        <b-tab
          :title="$t('My Project')"
          content-class="myProject"
          @click="tabChanged(true)"
        >
          <b-dropdown
            :text="getTabName"
            variant="outline-secondary"
            class="m-md-2"
            v-if="isAdmin"
          >
            <b-dropdown-item
              v-for="(value, key) in filteredTabs"
              :key="key"
              @click="changeTab(value)"
            >
              {{ value.nameKo }}
            </b-dropdown-item>
          </b-dropdown>
          <span v-if="isAdmin"> {{ $t('Copy to Sample') }} </span>
          <b-table
            striped
            hover
            selectable
            select-mode="single"
            :fields="fields"
            :items="myItems"
            @row-selected="onRowSelected"
            ref="myTable"
          >
            <template #cell(projectName)="row">
              <span>{{ row.item.projectName }}</span>
            </template>
            <template #cell(date)="row">
              <span>{{ row.item.date }}</span>
            </template>
            <template #cell(Buttons)="row">
              <b-button size="sm" variant="info" @click="rename(row)">
                <i class="fas fa-edit"></i>
                <span v-if="!phoneMode">{{ $t('Rename') }}</span>
              </b-button>
              <b-button size="sm" variant="danger" @click="remove(row)">
                <i class="fas fa-trash"></i>
                <span v-if="!phoneMode">{{ $t('Delete') }}</span>
              </b-button>
              <b-button
                size="sm"
                variant="success"
                @click="copyToSample(row)"
                v-if="isAdmin"
              >
                <i class="fas fa-copy"></i>
                <span v-if="!phoneMode">{{ $t('Copy to Sample') }}</span>
              </b-button>
            </template>
          </b-table>
        </b-tab>
        <b-tab
          :title="getSampleTitle(value)"
          v-for="(value, key) in filteredTabs"
          :key="key"
          content-class="sampleProject"
          @click="tabChanged(false)"
        >
          <b-table
            striped
            hover
            selectable
            select-mode="single"
            :fields="sampleFields"
            :items="getSampleItems(value)"
            v-if="isAdmin"
            @row-selected="onRowSelected"
            ref="sampleTable"
          >
            <template #cell(image)="row">
              <b-img
                :src="getImage(row.item)"
                fluid
                width="50"
                height="50"
              ></b-img>
            </template>
            <template #cell(projectName)="row">
              <span>{{ row.item.projectName }}</span>
            </template>
            <template #cell(date)="row">
              <span>{{ row.item.date }}</span>
            </template>
            <template #cell(Buttons)="row" v-if="isAdmin">
              <b-button size="sm" variant="info" @click="rename(row)">
                <i class="fas fa-edit"></i>
                <span v-if="!phoneMode">{{ $t('Rename') }}</span>
              </b-button>
              <b-button size="sm" variant="danger" @click="remove(row)">
                <i class="fas fa-trash"></i>
                <span v-if="!phoneMode">{{ $t('Delete') }}</span>
              </b-button>
            </template>
          </b-table>
          <b-card-group deck v-else>
            <b-card
              :title="project.projectName"
              :img-src="getImage(project)"
              img-top
              v-for="project in getSampleItems(value)"
              :key="project.fileName"
              @click="selectProject(project)"
              :class="{ selected: project === selectedProject }"
            >
              <i class="fa fa-check-circle" aria-hidden="true"></i>
            </b-card>
          </b-card-group>
        </b-tab>
      </b-tabs>
      <ProjectDetail :project="selectedProject" v-show="isShowProject" />
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100" v-show="!isShowProject">
        <div class="float-right">
          <b-button variant="success" size="sm" @click="newProject">
            {{ $t('New Project') }}
          </b-button>
          <b-button size="sm" @click="ok">{{ $t('Close') }}</b-button>
          <b-button
            size="sm"
            variant="info"
            @click="detail"
            :disabled="!selected"
            v-if="!isMyTab"
          >
            {{ $t('Detail') }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="open"
            :disabled="!selected"
          >
            {{ $t('Open') }}
          </b-button>
        </div>
      </div>
      <div class="w-100" v-show="isShowProject">
        <div class="float-right">
          <b-button size="sm" @click="unselectProject">
            {{ $t('Back') }}
          </b-button>
          <b-button size="sm" variant="info" @click="urlEdit" v-if="isAdmin">
            {{ $t('URL Edit') }}
          </b-button>
          <b-button variant="primary" size="sm" @click="open">
            {{ $t('Open') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ProjectDetail from '@/components/popup/ProjectDetail.vue'
import { mapState } from 'vuex'
import { project as projectController } from '@/controller'
import util from '@/libs/util'

export default {
  name: 'OpenProjectPopup',
  components: {
    ProjectDetail
  },
  data() {
    return {
      isShow: false,
      isShowProject: false,
      tabIndex: 0,
      tab: {},
      fields: [
        {
          key: 'projectName',
          label: this.$t('Name'),
          sortable: true
        },
        {
          key: 'date',
          label: this.$t('Date (Time)'),
          sortable: true
        },
        {
          key: 'Buttons',
          label: ''
        }
      ],
      myItems: [],
      sampleItems: {},
      calcItems: {},
      selectedProject: {},
      isMyTab: true
    }
  },
  computed: {
    ...mapState([
      'phoneMode',
      'project',
      'device',
      'devices',
      'filteredTabs',
      'isAdmin',
      'openProjectPopupData',
      'language'
    ]),
    sampleFields() {
      const fields = _.concat(
        [
          {
            key: 'image',
            label: ''
          }
        ],
        _.cloneDeep(this.fields)
      )
      _.find(fields, { key: 'date' }).label = this.$t('Date')
      if (this.isAdmin) return fields
      else return _.filter(fields, (f) => f.key !== 'Buttons')
    },
    getTabName() {
      return this.language === 'ko' ? this.tab.nameKo : this.tab.nameEn
    },
    selected() {
      return _.size(this.selectedProject) > 0
    }
  },
  methods: {
    async init(isReload) {
      log('init()')
      if (!isReload) {
        if (this.project.type === 'sample') {
          const index = _.findIndex(this.filteredTabs, { id: this.project.tab })
          this.tabIndex = index + 1
          this.isMyTab = false
        } else {
          this.tabIndex = 0
          this.isMyTab = true
        }
        this.tab = _.get(this.filteredTabs, '[0]', {})
      }
      await this.readMyItems()
      this.calcItems = {}
      for (let t in this.filteredTabs) {
        await this.readSampleItems(this.filteredTabs[t])
      }
      this.sampleItems = this.calcItems
      this.isShowProject = false
      this.selectedProject = {}
    },
    async readMyItems() {
      log('readMyItems()')
      this.myItems = []
      const projects = await projectController.list(this)
      _.each(_.orderBy(projects, 'timeStamp', 'desc'), (project) => {
        const { projectName, fileName, date, type, timeStamp } = project
        this.myItems.push({
          projectName,
          fileName,
          date,
          type,
          timeStamp
        })
      })
    },
    async readSampleItems(tab) {
      log('readSampleItems()')
      const sampleProjects = await projectController.list(this, tab.id)
      const sps = []
      _.each(sampleProjects, (project) => {
        const {
          projectNames,
          fileName,
          date,
          email,
          type,
          tab,
          timeStamp,
          image,
          youtube,
          circuit
        } = project
        let projectName = _.get(projectNames, 'en', '')
        if (_.get(projectNames, this.language))
          projectName = _.get(projectNames, this.language, '')
        sps.push({
          projectName,
          projectNames,
          fileName,
          date,
          email,
          type,
          tab,
          timeStamp,
          image,
          youtube,
          circuit
        })
      })
      this.calcItems[tab.id] = _.orderBy(sps, 'projectName', 'asc')
    },
    changeTab(tab) {
      log('changeTab()')
      this.tab = tab
    },
    getSampleTitle(tab) {
      const tabName = this.language === 'ko' ? tab.nameKo : tab.nameEn
      return `${tabName} ${this.$t('Sample')}`
    },
    getSampleItems(tab) {
      return this.sampleItems[tab.id]
    },
    getProject(item) {
      const project = util.getProject(item)
      return project
    },
    async selectProject(project) {
      this.selectedProject = project ? project : {}
    },
    async unselectProject() {
      this.isShowProject = false
    },
    async open() {
      this.isShow = false
      await projectController.open(this, this.selectedProject)
    },
    async detail() {
      this.isShowProject = true
    },
    async rename(row) {
      const project = this.getProject(row.item)
      const param = {
        callback: this.renameHandler,
        project,
        originProject: project
      }
      await projectController.rename(this, param)
    },
    async renameHandler(project, originProject) {
      await this.init(true)
      if (
        this.project.fileName === originProject.fileName &&
        this.project.type === project.type
      ) {
        await projectController.setCurrent(this, project)
      }
    },
    async urlEdit() {
      const param = {
        callback: this.urlEditHandler,
        project: this.selectedProject,
        originProject: this.selectedProject
      }
      await projectController.urlEdit(this, param)
    },
    async urlEditHandler(project, originProject) {
      await this.init(true)
      if (
        this.project.fileName === originProject.fileName &&
        this.project.type === project.type
      ) {
        await projectController.setCurrent(this, project)
      }
    },
    async remove(row) {
      const project = this.getProject(row.item)
      const param = {
        callback: this.removeHandler,
        originProject: project
      }
      await projectController.remove(this, param)
    },
    async removeHandler(originProject) {
      await this.init(true)
      if (
        this.project.fileName === originProject.fileName &&
        this.project.type === originProject.type
      ) {
        await projectController.removeCurrent(this)
      }
    },
    async copyToSample(row) {
      const project = this.getProject(row.item)
      const param = {
        callback: this.copyToSampleHandler,
        project,
        tab: this.tab
      }
      await projectController.saveCopy(this, param)
    },
    async copyToSampleHandler() {
      await this.init(true)
    },
    async newProject() {
      this.isShow = false
      await projectController.removeCurrent(this)
    },
    getImage(project) {
      const tab = _.find(this.filteredTabs, { type: _.get(project, 'tab') })
      const device = _.find(this.devices, { type: _.get(tab, 'type') })
      return project.image
        ? project.image
        : device
        ? device.imageUrl
        : undefined
    },
    onRowSelected(items) {
      this.selectProject(items[0])
    },
    tabChanged(isMyTab) {
      log('tabChanged()')
      this.isMyTab = isMyTab
      this.$refs.myTable.clearSelected()
      _.forEach(this.$refs.sampleTable, (t) => {
        t.clearSelected()
      })
      this.selectedProject = {}
    }
  },
  watch: {
    openProjectPopupData() {
      if (this.openProjectPopupData.isShow) {
        this.isShow = true
        this.init()
      } else {
        this.isShow = false
      }
    },
    isShow(newVal) {
      if (!newVal) {
        this.selectedProject = {}
        this.isShowProject = false
      }
    }
  }
}
</script>

<style scoped>
button.btn-primary {
  margin-right: 10px;
}

.container-fluid {
  padding-right: 10px;
  padding-left: 10px;
  text-align: center;
}

.container-fluid > * {
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .openProject .modal-body {
    padding: 1rem 0;
  }

  .openProject .container-fluid {
    padding-left: 3px;
    padding-right: 3px;
  }

  .openProject .table th,
  .openProject .table td {
    padding: 5px;
  }

  .card-deck {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    margin-left: -15px;
  }

  .card-deck .card {
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-left: 30px;
  }
}

@media only screen and (max-width: 1199px) {
  .modal-xl {
    max-width: 96%;
  }
}
</style>

<style>
.openProject .table thead th {
  white-space: nowrap;
}

.openProject .tab-pane[content-class='sampleProject'] .table thead th {
  min-width: 80px;
}

.openProject
  .tab-pane[content-class='myProject']
  .table
  tbody
  td[aria-colindex='1'] {
  width: 100%;
}

.openProject
  .tab-pane[content-class='myProject']
  .table
  tbody
  td[aria-colindex='2'],
.openProject
  .tab-pane[content-class='myProject']
  .table
  tbody
  td[aria-colindex='3'] {
  white-space: nowrap;
}

.openProject
  .tab-pane[content-class='sampleProject']
  .table
  tbody
  td[aria-colindex='1'] {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.openProject
  .tab-pane[content-class='sampleProject']
  .table
  tbody
  td[aria-colindex='2'] {
  width: 100%;
}

.openProject
  .tab-pane[content-class='sampleProject']
  .table
  tbody
  td[aria-colindex='3'],
.openProject
  .tab-pane[content-class='sampleProject']
  .table
  tbody
  td[aria-colindex='4'] {
  white-space: nowrap;
}

.openProject .table tbody tr:hover {
  background-color: #e5f3ff;
}

.openProject .table tbody tr.b-table-row-selected,
.openProject .table tbody tr.b-table-row-selected:hover {
  background-color: #cce8ff;
}

.table.b-table.table-hover > tbody > tr:hover td {
  background: transparent;
  /* border-color: #99D1FF; */
}

.openProject .table tbody tr.b-table-row-selected td,
.table.b-table.table-hover > tbody > tr.table-active:hover td {
  background: transparent;
  /* border-color: #99D1FF; */
}

.openProject .table tbody td {
  cursor: pointer;
}

.openProject .table button {
  margin-right: 10px;
}

.openProject .table button:last-child {
  margin-right: 0;
}

.openProject .table button span {
  margin-left: 5px;
}

.modal-footer button:not(:last-of-type) {
  margin-right: 10px;
}

.openProject .card-deck .card {
  min-width: 150px;
  max-width: 150px;
  margin-bottom: 20px;
  cursor: pointer;
}

.openProject .card-deck .card:hover {
  border: solid 1px #4242e2;
  outline: 1px solid #1616c4;
  outline-offset: -2px;
  opacity: 0.5;
}

.openProject .card-deck .card .card-body {
  position: relative;
  padding: 5px 10px;
}

.openProject .card-deck .card .card-title {
  font-size: 15px;
  margin-bottom: 0;
}

.openProject .card-deck .card svg {
  position: absolute;
  display: none;
  top: -140px;
  font-size: 20px;
  color: #3160b7;
  background-color: white;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.openProject .card-deck .card.selected svg {
  display: block;
}
</style>
